import React, {Component} from 'react';
import {Button} from 'react-bootstrap';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../../generics/help';
import { translate } from 'react-i18next';
import Parser from 'html-react-parser';
import $ from 'jquery';

const Config = require('../../../config');
var session = sessionStorage.getItem('health_facilities_name');

class Interview extends Component{
    constructor(props){
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.getQuestions = this.getQuestions.bind(this);
        this.onSave = this.onSave.bind(this);
        this.clear = this.clear.bind(this);
        this.getResponse = this.getResponse.bind(this);
        this.changeRadio = this.changeRadio.bind(this);
        this.onLast = this.onLast.bind(this);
        this.onNext = this.onNext.bind(this);
        this.validQuestion = this.validQuestion.bind(this);

        this.state = {
            no_offer:"",
            id:"",
            date:"",
            questions:[],
            questionary_id:"",
            disable:false,
            date_response:"",
            exclusion_by_questionnaire:{},
            index:0,
            name:""
        }

    }

    componentDidMount(){
        if(this.props.location.pathname !== '/interview'){
            this.setState({disable: true});
        }

        fetch(Config.default.apiGateway.URL+'functional_criterion?code=EXCLUSION_BY_QUESTIONNAIRE&x=',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      exclusion_by_questionnaire: response
            });
            
		})
    }

    getMessage(){
        fetch(Config.default.apiGateway.URL+'html_templates/self_exclusion_message',{
            method:'GET',
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Content-Type'  : 'application/json',
                'Accept'        : 'application/json'
            })
        }).then(res => {
            if(res.ok){
                return res.json();
            }else{
                res.text().then((msg)=>{
                    swal('Error', msg, 'error');
                })
            }
        }).then(response => {
            if(response !== undefined){
                if(response !== null){
                    var msg = JSON.parse(response);                
                    setTimeout(()=>{                    
                        swal({
                            title: '',
                            type: 'info',
                            html:true,
                            text:'<div>'+
                                msg[0]+
                            '</div>',
                        });
                    }, 500)
                }
                
            }
        })
    }

    handleChange(e){
        this.setState({[e.target.name]: e.target.value});
    }

    changeRadio(e){
        var questions = this.state.questions;
        var value = e.target.value;
        if(e.target.name === 'self_exclusion'){
            var id = e.target.name;
            var index = questions.findIndex(obj => obj.id === id);
            
            if(index !== -1){
                questions[index].value = value;
                questions[index].required = false;                
                if(questions[index].options.length > 0){
                    questions[index].options.map((option)=>{
                        if(option.value === value){
                            option.checked = true;
                        }else{
                            option.checked = false;
                        }

                    });
                }

            }

            this.setState({
                questions: questions,
                [e.target.name]: value === 'NO' ? false : true
            });
        }else{
            var id = parseInt(e.target.name);
            var index = questions.findIndex(obj => obj.id === id);
            
            if(index !== -1){
                questions[index].value = value;

                if(questions[index].options.length > 0){
                    questions[index].options.map((option)=>
                        option.value === value ?
                            option.checked = true
                        :
                            option.checked = false    
                    );
                }
            }

            this.setState({questions: questions});
        }
        
        if(e.target.type === 'radio'){
            this.onNext();
        }
        
    }

    onSearch(){
        this.props.waiting.handleShow('Buscando...');
        fetch(Config.default.apiGateway.URL+'offers/check/'+this.state.no_offer,{
            method:'GET',
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Accept'        : 'application/json',
                'Content-Type'  : 'application/json'
            })
        }).then(res => {
            this.props.waiting.handleClose();
            if(res.ok){
                return res.json();
            }else{
                res.text().then((msg) => {
                    swal('Error', msg, 'error');
                });
            }
        }).then(async response => {
            if(response !== undefined){
                await this.clear();
                
                await this.setState({
                    id:response.id,
                    name:response.donor_name,
                    date: moment(response.timestamp_date).format('DD/MM/YYYY')+' '+moment(response.timestamp_hour, 'HH:mm:ss.sssssss').format('HH:mm:ss')
                })

                swal({
                    title: "Alerta",
                    text: "Eres "+response.donor_name+"?",
                    type: "info",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Si",
                    cancelButtonText: "No"
                    //customClass: "Custom_Cancel"
                }, (isConfirm)=> {
                    if (isConfirm) {
                        this.getQuestions();
                        
                        if(this.state.exclusion_by_questionnaire.value === 'YES'){
                            this.getMessage();
                        }
                    }else{
                        this.clear();
                    }
                });

                
            }
        })
    }

    getQuestions(){
        fetch(Config.default.apiGateway.URL+'questionaries/by_center/'+sessionStorage.getItem('health_facilities_id'),{
            method:'GET',
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Accept'        : 'application/json',
                'Content-Type'  : 'application/json'
            })
        }).then(res => {
            this.props.waiting.handleClose();
            if(res.ok){
                return res.json();
            }else{
                res.text().then((msg) => {
                    swal('Error', msg, 'error');
                });
            }
        }).then(async response => {
            if(response !== undefined){
                response.questions.map((q)=>{
                    q.value = '';
                    q.options.map((option)=>
                        option.checked = false
                    );
                });
                
                if(this.state.exclusion_by_questionnaire.value === 'YES'){
                    response.questions.unshift({
                        field_label:'¿CONSIDERA QUE SU SANGRE ES SEGURA?',
                        field_type:'YES_NO',
                        id:'self_exclusion',
                        options:[{label:'SI, MI SANGRE ES SEGURA', value:'NO', checked:false},{label:'NO, MI SANGRE NO ES SEGURA', value:'YES', checked:false}],
                        value:"",
                        required:true,
                    });
                }

                await this.setState({questions: response.questions, questionary_id:response.id});

                if(this.state.disable){
                    await this.getResponse();
                }
                
            }
        })
    }

    getResponse(){
        fetch(Config.default.apiGateway.URL+'offer_questionnaire?offer_id='+this.state.id,{
            method:'GET',
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Accept'        : 'application/json',
                'Content-Type'  : 'application/json'
            })
        }).then(res => {
            this.props.waiting.handleClose();
            if(res.ok){
                return res.json();
            }else{
                res.text().then((msg) => {
                    swal('Error', msg, 'error');
                    this.setState({disable:false});
                });
            }
        }).then(response => {
            if(response !== undefined){
                var questions = this.state.questions;
                questions.map((q)=>{
                    
                    if(q.id === 'self_exclusion'){
                        q.value = response.self_exclusion === null ? '' 
                                : response.self_exclusion ? 'YES' : 'NO';
                        
                        q.options.map((option)=>{
                            if(option.value === q.value){
                                option.checked = true;
                            }
                        })
                    }else{
                        var index = response.questionnaire_response.findIndex(obj => obj.ask_id === q.id);
                        
                        if(index !== -1){                        
                            q.value = response.questionnaire_response[index].answer;

                            q.options.map((option)=>{
                                if(option.value === q.value){
                                    option.checked = true;
                                }
                            })
                            
                        }
                    }
                })

                this.setState({
                    questions: questions,
                    date_response: moment(response.timestamp).format('DD/MM/YYYY HH:mm:ss')
                })
            }
        })
    }

    onSave(e){
        e.preventDefault();
        var obj = {
            questionary_id: this.state.questionary_id,
            offer_id: this.state.id,
            questionnaire_response:[]
        };
        
        var valid = true;
        var index = -1
        this.state.questions.map((q, i)=>{            
            var item = {};
            
            if(q.value !== undefined && q.id !== "self_exclusion"){
                if(q.required && q.value === ""){
                    valid = false;
                    index = i;
                }else{
                    item = {
                        ask_id: q.id,
                        answer: q.value
                    };
    
                    obj.questionnaire_response.push(item);
                }
                
            }else{
                if(q.required && q.value === ""){
                    valid = false;
                    index = i;
                }
            }

            return q;
        });
        
        if(this.state.exclusion_by_questionnaire.value === 'YES'){
            obj.self_exclusion = this.state.self_exclusion;
        }else{
            obj.self_exclusion = null;
        }
        if(valid){
            if(obj.questionnaire_response.length > 0){
                this.props.waiting.handleShow('Guardando...');
                fetch(Config.default.apiGateway.URL+'offer_questionnaire',{
                    method:'POST',
                    body:JSON.stringify(obj),
                    headers: new Headers({
                        'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                        'Accept'        : 'application/json',
                        'Content-Type'  : 'application/json'
                    })
                }).then(res => {
                    this.props.waiting.handleClose();
                    if(res.ok){
                        return res.json();
                    }else{
                        res.text().then((msg) => {
                            swal('Error', msg, 'error');
                        });
                    }
                }).then(response => {
                    if(response !== undefined){
                        swal('Correcto', 'Los datos se guardaron correctamente', 'success');
                        this.clear();
                    }
                })
            }else{
                swal('Error', 'Debe contestar por lo menos una pregunta', 'error');
            }
        }else{
            swal('Error', 'La pregunta '+(index+1)+' debe ser contestada', 'error');
        }
    }

    isValidForm() {
		const inputs = document.querySelectorAll('select,input');
	    let isFormValid = true;
	    var vacio = false;

	    inputs.forEach(input => {
            if(input.required){
                const isInputValid = this.showCtrlError(input.id);
             
                if (!isInputValid) {                    
                    vacio = true;
                }
            }
	    });

	    if(vacio){
	    	isFormValid = false;
	    }

	    return isFormValid;
    }

    showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);

        if(control !== null){
            if(control.required){
                if(control.value === ""){
                    control.classList.add('error');
                    res = false;
                    
                }else{
                    if(control.className.includes('error')){
                        control.classList.remove('error');
                        
                    }
                    res = true;
                }

            }
        }
		
		return res;		
	}
    
    clear(){
        this.setState({
            no_offer:"",
            id:"",
            date:"",
            questions:[],
            questionary_id:"",
            date_response:"",
            index:0,
            name:""
        });
    }

    onLast(){
        if(this.state.index > 0){
            this.setState({
                index: this.state.index - 1
            });
        }
    }

    onNext(){
        if(!this.validQuestion(this.state.index)){
            if(this.state.index < this.state.questions.length - 1){
                this.setState({
                    index: this.state.index + 1
                });
            }
        }else{
            swal('Error', 'La pregunta debe ser contestada', 'error');
        }
        
    }

    validQuestion(index){
        var questions = this.state.questions;
        
        return questions[index].required && questions[index].value === "";
    }

    render(){
        const {t} = this.props;

        return(
            <div className="col-xs-12">
                <div className="route">
                    <h5 className="title_page" >
                        {session} ->
                        {t('sidebar.nav.donors.MAIN')} -> 
                        Encuesta
                    </h5>
                </div>

                <Help
                    {...this.props}
                    menu={"help_donors"} 
                    submenu={"help_offers_questionary"}  />
                
                <div className="col-xs-12">
                    <div className="col-xs-12">
                        <div className="col-xs-12 col-sm-8 col-md-4">
                            <div className="col-xs-12">
                                <span className="span-min" style={{fontSize:25}}>Número de ofrecimiento</span>
                            </div>
                            <div className="col-xs-12">
                                <div className="col-xs-12 col-sm-7" style={{padding:0}}>
                                    <input type="number" className="form-control input-sm hour-input" 
                                        name="no_offer" id="no_offer" value={this.state.no_offer} 
                                        onChange={(e)=>this.handleChange(e)}
                                    />
                                </div>
                                <div className="col-xs-12 col-sm-1" style={{marginTop:-3, fontSize:20}}>
                                    <button className="btn btn-info" onClick={()=>this.onSearch()}>Buscar</button>
                                </div>        
                            </div>                            
                        </div>
                        
                    </div>
                    {this.state.id !== "" &&
                        <div className="col-xs-12 questions-data">
                            <hr />
                            <div className="col-xs-12">
                                <div className="col-xs-12 col-sm-3">
                                    <span className="span-min" style={{fontSize:25}}>Id:</span>
                                </div>
                                <div className="col-xs-12 col-sm-9">
                                    <span>{this.state.id}</span>
                                </div>
                            </div>
                            <div className="col-xs-12">
                                <div className="col-xs-12 col-sm-3">
                                    <span className="span-min" style={{fontSize:25}}>Nombre:</span>
                                </div>
                                <div className="col-xs-12 col-sm-9">
                                    <span>{this.state.name}</span>
                                </div>
                            </div>
                            <div className="col-xs-12">
                                <div className="col-xs-12 col-sm-3">
                                    <span className="span-min" style={{fontSize:25}}>Fecha:</span>
                                </div>
                                <div className="col-xs-12 col-sm-9">
                                    <span>{this.state.date}</span>
                                </div>
                            </div>
                            {this.state.disable &&
                                <div className="col-xs-12">
                                    <div className="col-xs-12 col-sm-3">
                                        <span className="span-min" style={{fontSize:25}}>Respondido el:</span>
                                    </div>
                                    <div className="col-xs-12 col-sm-9">
                                        <span>{this.state.date_response}</span>
                                    </div>
                                </div>
                            }
                            
                        </div>
                    }

                    {this.state.questions.length > 0 &&
                        <form className="col-xs-12">
                            <hr/>
                            <div className="col-xs-12 form-group">
                                <fieldset style={{padding:8}}>
                                    <legend className="question-section">
                                        {this.state.exclusion_by_questionnaire.value === 'YES' ?
                                            this.state.index === 0 ? 'AUTOEXCLUSIÓN' : 'ENCUESTA'
                                        : 'ENCUESTA'}
                                    </legend>

                                    {this.state.questions[this.state.index] !== undefined &&
                                        <div className="col-xs-12 form-group question-data" style={{fontSize:'25px !important'}}>
                                            {this.state.questions[this.state.index].field_type !== 'DATE' &&
                                                <div className="colxs-12">
                                                    <span className="span-min" style={{fontSize:25}}>
                                                        {(this.state.index+1)+'.- '+this.state.questions[this.state.index].field_label}
                                                    </span>
                                                </div>
                                            }
                                            <div className="col-xs-12">                                                
                                                {this.state.questions[this.state.index].options.length > 0 ?
                                                    <div onChange={this.changeRadio}>
                                                        {this.state.questions[this.state.index].options.map((option, i)=>
                                                            <div className={this.state.index === 0 ? "col-xs-12 col-sm-4" :
                                                                this.state.questions[this.state.index].options.length > 4 ?
                                                                    "col-xs-12 col-sm-2"
                                                                : "col-xs-12 col-sm-3"} key={i} style={{textAlign:'center'}}>
                                                                <input 
                                                                    type="radio" 
                                                                    value={option.value} 
                                                                    name={this.state.questions[this.state.index].id} 
                                                                    checked={option.checked}
                                                                    style={{
                                                                        width:'25%',
                                                                        height:20
                                                                    }}
                                                                /> 
                                                                <span style={{display:'block'}}>{option.label}</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                :
                                                    <div className="col-xs-12 col-sm-8">
                                                        <textarea
                                                            id={this.state.questions[this.state.index].id} 
                                                            name={this.state.questions[this.state.index].id}
                                                            className="form-control" 
                                                            style={{fontSize:30, width:'100%', height:250, resize:'none'}} 
                                                            value={this.state.questions[this.state.index].value}
                                                            onChange={this.changeRadio}
                                                        ></textarea>
                                                    </div>
                                                }
                                                
                                            </div>
                                            
                                        </div>
                                    }
                                    {this.state.index < this.state.questions.length - 1 &&
                                        <div className="col-xs-12" style={{textAlign:'center'}}>
                                            {/*this.state.index > 0 && 
                                                <Button style={{fontSize:20}} onClick={()=>this.onLast()}>Anterior</Button>
                                            */}
                                            {this.state.questions[this.state.index] !== undefined ?
                                                this.state.questions[this.state.index].options.length === 0 ?
                                                    <Button onClick={()=>this.onNext()} style={{marginLeft:8, fontSize:20}}>Siguiente</Button>
                                                :null
                                            : null }
                                        </div>
                                    }                                    
                                </fieldset>
                            </div>
                            {this.state.index === this.state.questions.length - 1 && 
                                <div className="col-xs-12" style={{textAlign:'center'}}>
                                    <button className="btn btn-info" style={{fontSize:20}} onClick={(e)=>this.onSave(e)}>Guardar</button>
                                </div>
                            }
                        </form>
                    }

                </div>
            </div>
        )
    }
    
}

export default translate('translations')(Interview);